// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "@rails/actiontext";
import "./controllers";
import "react-trix-rte";
import "trix";
import "./assets/application.css";
